// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2911":"945c264f","4300":"44e79318"}[chunkId] + ".chunk.css";
};